import IAddressVm from "./../shared/IAddressVm"
import IApplicationVm from "./../shared/IApplicationVm"
import IEducationalInstitutionVm from "./../shared/IEducationalInstitutionVm"
import IMunicipalityVm from "./../shared/IMunicipalityVm"
import IServiceErrorVm from "./../home/Shared/IServiceErrorVm"
import { ActorSubmittingApplicationType } from "./../enums/ActorSubmittingApplicationType"
import { FormerLicenseType } from "./../enums/FormerLicenseType"
import { CertificateProcessType } from "./../flags/CertificateProcessType"
import { CertificateType } from "./../flags/CertificateType"

import * as IAddressVmInstance from "./../shared/IAddressVm"
import * as IMunicipalityVmInstance from "./../shared/IMunicipalityVm"
import * as IEducationalInstitutionVmInstance from "./../shared/IEducationalInstitutionVm"

export default interface ICreateApplicationForExemptedCitizenVm {
    applicationId?: string
    isNewApplicationCreated: boolean
    civilRegistrationIdentifier: string
    secondaryDeliveryAddress: IAddressVm
    useSecondaryDeliveryAddress: boolean
    certificateType: CertificateType
    certificateProcessType: CertificateProcessType
    formerLicenseType: FormerLicenseType
    formerIssuingMunicipality: IMunicipalityVm
    formerTaxLicenseNumber: string
    formerTaxLicenseExpireDate: string
    driverlicenseNumber: string
    phonenumber: string
    existingApplications: IApplicationVm[]
    errors: IServiceErrorVm[]
    actorSubmittingApplicationType: ActorSubmittingApplicationType
    educationalInstitution: IEducationalInstitutionVm
}

export const empty = (enableIteration: boolean = true): ICreateApplicationForExemptedCitizenVm => {
	return {
		applicationId: "",
		isNewApplicationCreated: false,
		civilRegistrationIdentifier: "",
		secondaryDeliveryAddress: IAddressVmInstance.empty(),
		useSecondaryDeliveryAddress: false,
		certificateType: CertificateType.NotSet,
		certificateProcessType: CertificateProcessType.NotSet,
		formerLicenseType: FormerLicenseType.NotSet,
		formerIssuingMunicipality: IMunicipalityVmInstance.empty(),
		formerTaxLicenseNumber: "",
		formerTaxLicenseExpireDate: "",
		driverlicenseNumber: "",
		phonenumber: "",
		existingApplications: [] as IApplicationVm[],
		errors: [] as IServiceErrorVm[],
		actorSubmittingApplicationType: ActorSubmittingApplicationType.NotSet,
		educationalInstitution: IEducationalInstitutionVmInstance.empty()
	} as ICreateApplicationForExemptedCitizenVm
}